import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Rückholungen')
    .setChildren([
        MenuEntry.create()
            .setRoute('return_request_emons_config'),
    ]);
